export default __webpack_public_path__ + "static/media/Set_reminders.274509dd.png";